import * as React from "react";
import { makeStyles } from "@material-ui/core";
import { Field, FieldProps, Formik } from "formik";
import { DatePicker } from "src/common/components";

const useStyles = makeStyles({
  datepickerBtnWrapperClass: {
    "& button": {
      width: 152
    },
    "& button [data-qa-selector=datePickerCalendarIcon]": {
      marginRight: 14,
      position: "absolute" as "absolute",
      right: 0
    },
    "& button [data-qa-selector=datePickerTextContainer]": {
      width: 95
    }
  }
});

interface IOwnProps {
  onSubmit: (data: any) => void;
  initialValues: any;
}

const ScheduleTalkDateForm = ({ onSubmit, initialValues }: IOwnProps) => {
  const classes = useStyles();

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {({ handleSubmit, submitForm }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Field name="scheduledDate">
              {({ field: { name, value }, form: { setFieldValue } }: FieldProps) => {
                const handleDateChange = (newDate: Date) => {
                  setFieldValue(name, newDate);
                  setTimeout(submitForm, 0);
                };

                return (
                  <DatePicker
                    disablePast
                    defaultValue={value}
                    onChange={handleDateChange}
                    btnWrapperClass={classes.datepickerBtnWrapperClass}
                  />
                );
              }}
            </Field>
          </form>
        );
      }}
    </Formik>
  );
};

export default React.memo(ScheduleTalkDateForm);
